module.exports = __webpack_public_path__ + "static/media/mail.9b403b74.svg";